export var LANDING_PAGE_BASE_PATH = "/landing-page";
export var pageRoutes = {
    LANDING_PAGE: LANDING_PAGE_BASE_PATH,
    PICKER_PAGE: "/global-picker"
};
export var PROFILE_PAGE = "/profile";

//# sourceMappingURL=routes.js.map